/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus;
(function (FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus) {
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus[FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus["Created"] = 0] = "Created";
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus[FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus["Cancelled"] = 1] = "Cancelled";
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus[FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus["Completed"] = 2] = "Completed";
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus[FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus || (FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus = {}));
export function instanceOfFxIdDomainModelsDBStoreDBOrderOptimisticUserStatus(value) {
    for (const key in FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, key)) {
            if (FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSON(json) {
    return FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSONTyped(json, false);
}
export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSON(value) {
    return value;
}
export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.js.map